import { ProjectService } from '../../types/entities';
import { getURLSafeFilePath, getFileName } from '../file/file-path';
import { MediaAsset } from '../../types/media-assets';

const UNSUPPORTED_BROWSER_IMAGE_EXTENSIONS = ['heic'];
const UNSUPPORTED_BROWSER_MIMETYPES = ['image/heic'];

function replaceExtension(fileName: string, extension: string) {
  return fileName.replace(/\.([^/.]+)$/, `.${extension}`);
}

export function getResizedImageUrl(
  imageService: ProjectService,
  filePath: string,
  width: number,
  height: number,
  token?: string,
  extension?: string,
): string {
  filePath = getURLSafeFilePath(filePath);

  let fileName: string = getFileName(filePath);

  if (extension) {
    fileName = replaceExtension(fileName, extension);
  }
  const tokenQuery = (token && `?token=${token}`) || '';

  return `https://${imageService.host}${filePath}/v1/fit/w_${width},h_${height},enc_auto/${fileName}${tokenQuery}`;
}

function getFileExtension(path: string) {
  return path.split('.').pop();
}

export function getImageExtension(file: MediaAsset): string {
  let extension: string;

  const unsupportedExtension = UNSUPPORTED_BROWSER_IMAGE_EXTENSIONS.includes(
    getFileExtension(file.path).toLowerCase(),
  );

  const unsupportedMimeType = UNSUPPORTED_BROWSER_MIMETYPES.includes(
    file.mimeType.toLowerCase(),
  );

  if (unsupportedExtension || unsupportedMimeType) {
    extension = 'jpg';
  }

  return extension;
}
